import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "./assets/constant";
import { useSelector } from "react-redux";

export const CheckAuth = () => {
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  return isLoggedIn ? <Outlet /> : <Navigate to={ROUTES.LOGIN} />;
};

export const CheckSubscription = () => {
  const user = useSelector((state) => state.auth);
  const hasSubscription = user.subscription && user.subscription.length > 0;
  return hasSubscription ? <Outlet /> : <Navigate to={ROUTES.MANAGE_SUBSCRIPTION} />;
};